// De teksten en gegevens die de beheerder aanpaste (Backoffice › Teksten, zie src/content.js). De server zet ze in de
// pagina als <script type="application/json" id="bw-content">, in de taal van de pagina: zo zijn ze er meteen, zonder
// extra verzoek. De teksten gaan via lib/i18n.js, de gegevens (veelgestelde vragen, maanden) via i18n/data.js.
import { getLang, setCustomTexts } from './i18n.js';

let data = null;

/** Leest de aanpassingen uit de pagina en zet de teksten klaar; geeft de gegevens (of null). */
export function readPageContent() {
  let parsed = null;
  try {
    parsed = JSON.parse(document.getElementById('bw-content')?.textContent || 'null');
  } catch {
    parsed = null;
  }
  if (parsed?.texts) setCustomTexts({ [getLang()]: parsed.texts });
  data = parsed?.data && Object.keys(parsed.data).length ? parsed.data : null;
  return data;
}

export const pageContentData = () => data;
